import React, { useEffect, useState, useRef } from 'react';
import LoginDialog from '../components/dialog/LoginDialog';
import { firebaseConfig } from '../utils/firebase'
import RegistrationDialog from '../components/dialog/RegistrationDialog';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { trackPageView } from '../utils/analytics';

const NativePage = ({ content }) => {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const { user } = useAuth();

    const iframeRef = useRef();
    const [loginOpen, setLoginOpen] = useState(false);
    const [registrationOpen, setRegistrationOpen] = useState(false);

    useEffect(() => {
        const url = document.location.pathname + document.location.search;
        trackPageView(url);

        const handler = (event: MessageEvent) => {
            if (event.data.type === "JUMP_LANDING") {
                navigate("/");
            }
            if (event.data.type === "JUMP_LEGAL") {
                navigate("/legal");

            }
            if (event.data.type === "JUMP_GDPR") {
                navigate("/gdpr");
            }
            if (event.data.type === "JUMP_COOKIES") {
                navigate("/cookies");
            }
        };

        window.addEventListener("message", handler);
        return () => window.removeEventListener("message", handler);
    });

    useEffect(() => {
        if (user && user.email) {
            setIsLoggedIn(true)
            iframeRef.current?.contentWindow?.postMessage(
                { type: "LOGGED_IN", payload: "" },
                "*"
            );
        } else {
            setIsLoggedIn(false)
        }
    }, [user])

    return (
        <div style={{ background: "#212529" }}>
            <iframe
                ref={iframeRef}
                src={"/landing/" + content}
                title={isLoggedIn ? "LOGGED IN in Landing Page" : "Landing Page"}
                style={{ border: 'none', width: '100vw', height: '100vh' }}
            />
            <LoginDialog
                open={loginOpen}
                onClose={() => setLoginOpen(false)}
                onSuccess={() => {
                    navigate("/home")
                }}
                firebaseConfig={firebaseConfig} // alebo zdieľaný `auth` cez props
            />
            <RegistrationDialog
                open={registrationOpen}
                onLoginClick={() => {
                    setRegistrationOpen(false);
                    setLoginOpen(true);
                }}
                onClose={() => setRegistrationOpen(false)}
                onSuccess={(cred) => {
                    console.log('Registrovaný:', cred.user);
                }}
                firebaseConfig={firebaseConfig}
            />
        </div>
    );
};

export default NativePage;
